import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#0066CC',
      dark: '#0052A3',
      light: '#42A5F5',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#00A9A5',
      dark: '#009B97',
      light: '#4DD2D0',
      contrastText: '#ffffff',
    },
    background: {
      default: '#F8FAFC',
      paper: '#ffffff',
    },
    success: {
      main: '#17BF63',
      dark: '#0F8D48',
      light: '#81C784',
    },
    warning: {
      main: '#FF9500',
      dark: '#E67E00',
      light: '#FFB74D',
    },
    error: {
      main: '#E0245E',
      dark: '#B01A4A',
      light: '#E57373',
    },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          borderRadius: 12,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
      },
    },
  },
});
